import { ProductType } from '../Layout/Promotions/PromotionsBlock/types';
import { IconVariant } from '../shared/Icon';

/**
 * Generic navigation link
 */
export type NavigationLink = {
  /**
   * Visible label
   */
  label: string;
  /**
   * URL the link is pointing to
   */
  url: string;
  /**
   * Inactive link icon
   */
  icon: IconVariant;
  /**
   * Active link icon
   */
  iconActive: IconVariant | string;
  /**
   * Games category slug
   */
  slug: string;
};

export type NavigationCustomLink = {
  /**
   * Link type
   */
  type: ProductType;
  /**
   * Visible label
   */
  label: string;
  /**
   * Link icon
   */
  iconLink?: string;
  /**
   * Active iink icon
   */
  activeIconLink?: string;
};

/**
 * Auth and not auth properties
 */
type AuthUnAuthPermit = {
  /**
   * Show/hide link to authenticated users
   */
  authenticated: boolean;
  /**
   * Show/hide link to unauthenticated users
   */
  unauthenticated: boolean;
};

/**
 * Product Category navigation link
 * Extends generic navigation link
 */
export type ProductCategoryLink = AuthUnAuthPermit &
  NavigationLink & {
    /**
     * Tile row collection configuration for grid layouts
     */
    tile_row_collection?: {
      id: string;
      SeeMoreViewAll: boolean;
      Width: string;
      half_width_tile?: TileRowSection;
      first_full_width_tile?: TileRowSection;
      second_full_width_tile?: TileRowSection;
      third_full_width_tile_block?: TileRowSection;
      internal_name: string;
      __typename?: string;
    };
  };

type TileRowSection = {
  type: string;
  custom_tile_id?: string;
  __typename?: string;
};

export type PromotionCategoryLink = AuthUnAuthPermit & NavigationCustomLink;

export type PromoTab = {
  id: ProductType;
  name: ProductType;
};

export type Promotions = {
  tabs: PromoTab[];
};

export enum CategoryOfUsers {
  AllUser = 'allUsers',
  Authenticated = 'authenticated',
  AuthenticatedVip = 'authenticated-vip',
  AuthenticatedInvitedVip = 'authenticated-invited-vip',
  AuthenticatedNonVip = 'authenticated-non-vip',
  Unauthenticated = 'unauthenticated',
}
